import * as React from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { PaginationItem } from '@mui/material';

export default function BasicPagination({
  currentPage,
  totalPages,
  handleChangePage,
  status,
}) {
  const handleChange = (event, page) => {
    handleChangePage(status, page);
  };
  return (
    <Stack spacing={2} className="custom_pagination">
      <Pagination
        count={totalPages}
        page={currentPage}
        boundaryCount={2}
        onChange={handleChange}
        color="primary"
        renderItem={(item) => <PaginationItem {...item} disabled={item.selected || item.disabled} />}
      />
    </Stack>
  );
}
